import { HttpClient, HttpRequest, HttpEventType, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {

  constructor(private http: HttpClient, private toastr: ToastrService) { }

  downloadFile(url: string, fileName: string): void {
    const req = new HttpRequest('GET', url, {
      reportProgress: true,
      responseType: 'blob',
    });

    this.http.request(req).subscribe((event) => {
      console.log(event, HttpEventType);
      if (event.type === HttpEventType.DownloadProgress) {
        if (event.total !== undefined) {
          const percentDone = Math.round((100 * event.loaded) / event.total);
          this.toastr.info(`Downloading... ${percentDone}%`, '', {
            progressBar: true,
            progressAnimation: 'increasing'
          });
        } else {
          this.toastr.info('Downloading file...', '', {
            progressBar: true,
            progressAnimation: 'increasing'
          });
        }
      } else if (event.type === HttpEventType.Response) {
        this.toastr.clear();
        if (event.body instanceof Blob) {
          this.saveFile(event.body, fileName);
        } else {
          this.toastr.error('Failed to download the file.');
        }
      }
    });
  }

  private saveFile(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    anchor.click();
    window.URL.revokeObjectURL(url);
  }
}
